import { MenuItem } from 'shared';

import { useAddBacklogChallenge } from 'features/planning';

export const PlanningBacklogAddChallengeButton = () => {
  const openAddChallengeModal = useAddBacklogChallenge();

  return (
    <MenuItem
      onClick={openAddChallengeModal}
      data-testid="add-challenge-backlog-option"
    >
      Add challenge
    </MenuItem>
  );
};
